import line from './line';
import area from './area';
import bar from './bar';
import candlestick from './candlestick';
import baseline from './baseline';
import heikinAshi from './heikinAshi';

export const markRegistry = { line, area, bar, candlestick, baseline, heikinAshi };

export const markList = [line, area, candlestick, bar, baseline, heikinAshi];

export default markRegistry;
